import { isExpired } from "./utils.js";

const KEY = "dc_c_data";
const TTL_7_DAYS = 7 * 24 * 60 * 60 * 1000;

export function getCData() {
  const raw = localStorage.getItem(KEY);
  const cData = raw ? JSON.parse(raw) : {};

  if (isExpired(cData.timestamp, TTL_7_DAYS)) {
    localStorage.removeItem(KEY);
    return {};
  }
  const result = {
    c_src: cData.c_src || null,
    c_mod: cData.c_mod || null,
    c_info: cData.c_info || null
  }
  Object.entries(result).forEach(([key, value]) => {
    if (value === null) {
      delete result[key];
    }
  });
  return result;
}

export function saveCData(src, mod, info) {
  localStorage.setItem(
    "dc_c_data",
    JSON.stringify({
      c_src: src || null,
      c_mod: mod || null,
      c_info: info || null,
      timestamp: Date.now()
    })
  );
}
